import { useSelector } from 'react-redux';

import { AUD_DESKTOP_MENU } from '../constants/experiments';
import { selectExperiments } from '../selectors/experiments';
import { useApplicationContext } from '../utils/applicationContext';
import { isExperimentActive } from '../utils/experiments';

export function useMenuEnabled() {
  const experiments = useSelector(selectExperiments);
  const { config } = useApplicationContext();

  const isMenuEnabled = config.get<boolean>('header-frontend.menuButton.Enabled') || false;

  const activeGroup = isExperimentActive(experiments, AUD_DESKTOP_MENU, 'B');

  return Boolean(isMenuEnabled && activeGroup);
}
